import { Text, Flex } from '@chakra-ui/react';
import { NoDataTextSmall } from 'lib/components/NoData/NoData';
import moment from 'moment';
import { Fragment } from 'react';

export const Statistic = ({ value, unit, durationFormat, isSmall = false, dark, ...rest }) => {
    let formatted;
    if (value && typeof value === 'number') {
        formatted = durationFormat
            ? moment.duration(value).format(durationFormat, {
                  usePlural: false,
              })
            : parseFloat(value.toFixed(2));
    }

    const realValue = formatted || value;

    return (
        <Flex alignItems="baseline" {...rest}>
            {realValue != null && (
                <Fragment key="realValue">
                    <Text color={dark ? 'black' : 'white'} fontSize={isSmall ? 'md' : '2xl'} fontWeight="bold" pr={0.5}>
                        {realValue}
                    </Text>

                    <Text color={dark ? 'black' : 'gray2'} fontSize={isSmall ? '9px' : '13px'}>
                        {unit}
                    </Text>
                </Fragment>
            )}
            {realValue == null && <NoDataTextSmall />}
        </Flex>
    );
};
